// import http from './httpsemtoken'

import http from './httpsemtoken'

// import axios from 'axios'
let url = 'AutoAtendimento/'
// require('@/service/service_autoatendimento/httpsemtoken')
// const urlAdaptor = localStorage.getItem('APIAdaptor')
// // var http = axios.create({
// //   baseURL:urlAdaptor
// // })



export function postSolicitaCodigo (payload) {
  return http.post(url + 'notificaPrimeiroAcesso', payload)
}
export function getValidaCpfCnpj(payload) {
  return http.get(url + payload)
}
// Documentos
export function getComoFunciona() {
  return http.get(url + 'DocComoFunciona')
}
export function getQuemSomos() {
  return http.get(url + 'DocQuemSomos')
}
export function getContato() {
  return http.get(url + 'DocContato')
}
export function getDocPoliticaPrivacidade() {
  return http.get(url + 'DocPoliticaPrivacidade')
}
export function getDocTermoUso() {
  return http.get(url + 'DocTermoUso')
}
export function getAceite(cdPessoa) {
  return http.get(`${url}aceite/${cdPessoa}`)
}
export function postAceite(payload) {
  return http.post(`${url}aceite`, payload)
}